module.exports = __webpack_public_path__ + "img/nao.0213c620.png";